import { ApiService } from '../../services/api_service';
import { ContextService } from '../../services/context_service';

// GLOBALE FEHLER
let hadError = false;
let userName = '';
let context: any = {};

export function setUserForError(user: string) {
    userName = user;
}

export function setContextForError(c: any) {
    context = c;
}

export function initErrorCatching() {
    if (!window) {
        return;
    }
    window.onerror = function (msg, url, line, col, error) {
        window.setTimeout(() => processError(msg, url, line, col, error), 2000);
    };
    // Zum Testen ....
    // const test: any = undefined;
    // test.a = 1;
}

export function processError(msg: string | Event, url: string, line: number, col: number, error: any) {
    console.error(error);
    if (!document) {
        return;
    }
    if (hadError) {
        return; // nur den 1. Fehler (die Fehler kommen immer doppelt ...)
    }
    hadError = true;
    try {
        const msg_str = 'Es ist ein unerwarteter Fehler aufgetreten. Das E-Tool wird neu geladen.\n\nDamit wir Fehler wie diesen zukünftig vermeiden können, würden wir Sie bitten,\nuns eine kurze Fehlerbeschreibung an\n\n        service@energie-tool.de\n\nzu senden.\n\nFalls sie jetzt eine E-Mail schreiben möchten, klicken Sie bitte auf "OK".\n\nVielen Dank!';
        console.log(error.stack);
        const errormsg = msg + '<br>'
            + 'User: ' + userName + '<br>'
            + 'Unternehmen: ' + JSON.stringify(ApiService.unternehmenInternal) + '<br>'
            + 'Browser: ' + navigator.userAgent + '<br>'
            + 'Quelle: ' + url + '<br>' + 'Linie/Zeile: ' + line + ':' + col + '<br>'
            + 'Error: ' + error.name + '<br><hr>'
            + 'Context: ' + JSON.stringify(context) + '<br><hr>'
            + 'Context-Log: ' + JSON.stringify(ContextService.changeList) + '<br><hr>'
            + 'Stack: ' + error.stack + '<br><hr>'
            + 'Last Calls: ' + JSON.stringify(ApiService.callList);
        console.log(error.stack);
        console.log(errormsg);
        if (window.confirm(msg_str)) {
            const a = document.createElement('a');
            a.target = '_blank';
            a.href = 'mailto: service@energie-tool.de?subject=Fehlerbeschreibung E-Tool';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }
        if (true) {
            // setErrorLog() in api.mail.class.php
            const sendTo = 'etoolerrors@wipscom.de';
            const error_data: any = {
                unternehmen: ApiService.unternehmenInternal,
                module: ApiService.module,
                bereichKey: ApiService.bereichKey,
                error: error.name,
                stack: (error.stack || '').split(`\n`),
                call: ApiService.callList.slice(Math.max(ApiService.callList.length - 10, 0)),
                context,
                browser: navigator.userAgent
            };
            sendErrorAndReload('core', sendTo, 'Fehlermeldung', errormsg, error_data);
        } else {
            const currentPage = new URL(window.location.href);
            currentPage.searchParams.set('t', (new Date().getTime()) + '');
            window.location.href = currentPage.href;
        }
    } catch (e) {
        console.error(e);
    }
    return;
}

export function sendErrorAndReload(module: string, email: string, subject: string, text: string, error_data: any) {
    const conf = require('../../wips.config');
    const url = conf.api_url;
    const sendData = {
        mod_state: 'sendMail',
        override: 1,
        module: module,
        emailTo: email,
        subject: subject,
        text: text,
        // set_error_log: 1,
        // error_data
    };
    $.ajax({
        method: 'POST',
        url: url,
        data: sendData,
        error: (xhr, status) => {
            const currentPage = new URL(window.location.href);
            currentPage.searchParams.set('t', (new Date().getTime()) + '');
            window.location.href = currentPage.href;
        }
    })
        .done(function (data: string) {
            const currentPage = new URL(window.location.href);
            currentPage.searchParams.set('t', (new Date().getTime()) + '');
            window.location.href = currentPage.href;
        })
        .fail(function () {
            const currentPage = new URL(window.location.href);
            currentPage.searchParams.set('t', (new Date().getTime()) + '');
            window.location.href = currentPage.href;
        });
}

